export { default as translations } from './translations.json';

/**
 * Get ranking score from user.
 * @param {Object|null} user
 * @returns {number|null}
 */
export const getRankingScore = (user) =>
  user?.attributes?.profile?.metadata?.rankingScore ?? null;

/**
 * Sort providers by ranking score (descending).
 * @param {Object[]} users
 * @returns {Object[]}
 */
export const sortByRanking = (users) => {
  if (!Array.isArray(users)) return [];
  return [...users].sort((a, b) => {
    const scoreA = getRankingScore(a) ?? -1;
    const scoreB = getRankingScore(b) ?? -1;
    return scoreB - scoreA;
  });
};

/**
 * Check if provider is in top tier (score >= 80).
 * @param {Object|null} user
 * @returns {boolean}
 */
export const isTopProvider = (user) =>
  (getRankingScore(user) ?? 0) >= 80;
